import { clsx } from 'clsx';
import React from 'react';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';
import classes from './Flash.module.css.js';
import { jsx } from 'react/jsx-runtime';

const Flash = /*#__PURE__*/React.forwardRef(function Flash({
  as,
  className,
  variant = 'default',
  full,
  sx,
  ...rest
}, ref) {
  return /*#__PURE__*/jsx(BoxWithFallback, {
    ...rest,
    ref: ref,
    as: as,
    className: clsx(classes.Flash, className),
    "data-full": full ? '' : undefined,
    "data-variant": variant,
    sx: sx
  });
});
if (process.env.NODE_ENV !== "production") {
  Flash.displayName = 'Flash';
}

export { Flash as default };
